/**
 * Logger 설정
 * Feature-Sliced Design: shared/lib/logger
 *
 * 환경별 로그 레벨 자동 설정:
 * - Test: silent (로그 출력 없음)
 * - Development: debug (모든 로그 표시)
 * - Production: info (중요 로그만)
 */

import type { LogLevel, LoggerConfig } from './types';

/**
 * 현재 환경 감지
 */
const isDevelopment = import.meta.env.DEV;
const isTest = import.meta.env.MODE === 'test';

/**
 * 환경에 따른 로그 레벨 자동 결정
 *
 * @returns 현재 환경에 맞는 로그 레벨
 */
export const getLogLevel = (): LogLevel => {
  if (isTest) return 'silent';
  if (isDevelopment) return 'debug';
  return 'info'; // production
};

/**
 * 기본 Logger 설정
 */
export const defaultConfig: LoggerConfig = {
  level: getLogLevel(),
  fancy: isDevelopment, // 개발 환경에서만 색상/아이콘 사용
  tag: '', // 필요시 프로젝트명으로 변경 가능 (예: 'Phoneboard')
};

/**
 * Consola level number 매핑
 * Consola는 숫자로 level을 받음
 */
export const getLevelNumber = (level: LogLevel): number => {
  switch (level) {
    case 'silent':
      return 0;
    case 'fatal':
      return 0;
    case 'error':
      return 0;
    case 'warn':
      return 1;
    case 'info':
      return 2;
    case 'debug':
      return 3;
    case 'trace':
      return 4;
    default:
      return 2;
  }
};
